import { useMutation } from "@apollo/client/react";
import { useCallback } from "react";

import { StackDependency, StackDependencyInput } from "types/generated";

import { CREATE_STACK_DEPENDENCIES_IN_BATCH } from "./gql";

const useCreateStackDependenciesInBatch = () => {
  const [createStackDependenciesInBatch] = useMutation<{
    stackDependenciesCreateInBatch: Pick<StackDependency, "id">[];
  }>(CREATE_STACK_DEPENDENCIES_IN_BATCH, {
    refetchQueries: ["GetStack"],
  });

  const handleCreateDependenciesInBatch = useCallback(
    (dependencies: StackDependencyInput[]) => {
      return createStackDependenciesInBatch({
        variables: {
          input: { dependencies },
        },
      });
    },
    [createStackDependenciesInBatch]
  );

  return {
    handleCreateDependenciesInBatch,
  };
};

export default useCreateStackDependenciesInBatch;
